// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  StatsTable,AnimatedView,GameTypeTab
}                         from '../../components';



class Cohort extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
    })
  };

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Cohort');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Cohort');
  }

  render() {
    const {
      statsTable
    } = this.props;
    
    const { 
      actions: {
        fetchStatsTableDataIfNeeded
      }
    } = this.props;    

    return(
      <AnimatedView>

        <div className="row">
          <div className="col-md-12">
            <GameTypeTab name="cohort" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
        </div>
      </AnimatedView>
    );
  }
}

export default Cohort;



// WEBPACK FOOTER //
// ./src/app/views/cohort/Cohort.js